export default __webpack_public_path__ + "static/msdynamics-3af43d0153d68ebd79c3cba2cd5c24f2.svg";